exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1RmD1{width:425px;padding:0 50px;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;height:100%;margin:0 auto;-ms-flex-pack:center;justify-content:center}@media (max-width:549px){._1RmD1{width:355px;padding:0 15px}}._34O5v{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;padding:18px 0}", ""]);

// exports
exports.locals = {
	"embed-form": "_1RmD1",
	"embedForm": "_1RmD1",
	"size-picker": "_34O5v",
	"sizePicker": "_34O5v"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/containers/share-overlay/embed-form/embed-form.styl
// module id = 1443
// module chunks = mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals widget/strip widget/classic widget/compact